import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a84675c from 'nuxt_plugin_plugin_1a84675c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_a6927c3e from 'nuxt_plugin_recaptcha_a6927c3e' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_passwordprotect_5389fbe9 from 'nuxt_plugin_passwordprotect_5389fbe9' // Source: ./password-protect.js (mode: 'all')
import nuxt_plugin_image_7d68b96d from 'nuxt_plugin_image_7d68b96d' // Source: ./image.js (mode: 'all')
import nuxt_plugin_interpolation_108ad0f8 from 'nuxt_plugin_interpolation_108ad0f8' // Source: ./interpolation.js (mode: 'client')
import nuxt_plugin_portalvue_365f2721 from 'nuxt_plugin_portalvue_365f2721' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_3a8ae409 from 'nuxt_plugin_pluginutils_3a8ae409' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_79629314 from 'nuxt_plugin_pluginrouting_79629314' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_29c150db from 'nuxt_plugin_pluginmain_29c150db' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_dayjsplugin_3994cfaa from 'nuxt_plugin_dayjsplugin_3994cfaa' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axios_db3c871c from 'nuxt_plugin_axios_db3c871c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginnuxt2client_0e2fb0de from 'nuxt_plugin_pluginnuxt2client_0e2fb0de' // Source: ../.vercel/builders/node_modules/@nuxtjs/web-vitals/dist/runtime/plugin.nuxt2.client.mjs (mode: 'client')
import nuxt_plugin_deviceplugin_04127c06 from 'nuxt_plugin_deviceplugin_04127c06' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_bus_74da53e4 from 'nuxt_plugin_bus_74da53e4' // Source: ../plugins/bus.js (mode: 'all')
import nuxt_plugin_globalvars_698bce5e from 'nuxt_plugin_globalvars_698bce5e' // Source: ../plugins/globalvars.js (mode: 'all')
import nuxt_plugin_dayjs_6788fac9 from 'nuxt_plugin_dayjs_6788fac9' // Source: ../plugins/dayjs.js (mode: 'all')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_transitions_02e2df22 from 'nuxt_plugin_transitions_02e2df22' // Source: ../plugins/transitions.js (mode: 'all')
import nuxt_plugin_vuefinalmodal_130811df from 'nuxt_plugin_vuefinalmodal_130811df' // Source: ../plugins/vue-final-modal.js (mode: 'all')
import nuxt_plugin_notifications_36de4932 from 'nuxt_plugin_notifications_36de4932' // Source: ../plugins/notifications (mode: 'client')
import nuxt_plugin_videobg_32dbd9e4 from 'nuxt_plugin_videobg_32dbd9e4' // Source: ../plugins/videobg.js (mode: 'client')
import nuxt_plugin_excelexport_8371eefa from 'nuxt_plugin_excelexport_8371eefa' // Source: ../plugins/excelexport.js (mode: 'client')
import nuxt_plugin_vercel_006a881a from 'nuxt_plugin_vercel_006a881a' // Source: ../plugins/vercel.js (mode: 'client')
import nuxt_plugin_vue2smoothscroll_c0a59916 from 'nuxt_plugin_vue2smoothscroll_c0a59916' // Source: ../plugins/vue2-smooth-scroll.js (mode: 'client')
import nuxt_plugin_aos_78651e70 from 'nuxt_plugin_aos_78651e70' // Source: ../plugins/aos.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"titleTemplate":"Dubai Financial Market - %s","title":"Region’s leading financial exchange","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Dubai Financial Market (DFM) is The global destination for individuals and companies to accelerate their wealth and businesses with innovative products and services in conducting trading, clearing, settlement and depository of securities, in an efficient, transparent and liquid environment."},{"hid":"og-description","name":"og:description","content":"Dubai Financial Market (DFM) is The global destination for individuals and companies to accelerate their wealth and businesses with innovative products and services in conducting trading, clearing, settlement and depository of securities, in an efficient, transparent and liquid environment."},{"hid":"og-image","property":"og:image","content":"https:\u002F\u002Fres.cloudinary.com\u002Fdubaifinancialmarket\u002Fimage\u002Fupload\u002Fv1666878838\u002Fvisuals\u002Fdfm-image-013149_begl1w_hero.jpg"},{"hid":"og-title","property":"og:title","content":"Dubai Financial Market"},{"hid":"og-type","property":"og:type","content":"Article"},{"name":"format-detection","content":"telephone=no"},{"hid":"author","property":"author","content":"Dubai Financial Market"},{"hid":"copyright","property":"copyright","content":"Dubai Financial Market"}],"link":[{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-origin-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com\u002F"}],"style":[],"script":[{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Coda:wght@400&family=Almarai:wght@300;400;700&family=DM Sans:wght@400;500;700&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Coda:wght@400&family=Almarai:wght@300;400;700&family=DM Sans:wght@400;500;700&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a84675c === 'function') {
    await nuxt_plugin_plugin_1a84675c(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_a6927c3e === 'function') {
    await nuxt_plugin_recaptcha_a6927c3e(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordprotect_5389fbe9 === 'function') {
    await nuxt_plugin_passwordprotect_5389fbe9(app.context, inject)
  }

  if (typeof nuxt_plugin_image_7d68b96d === 'function') {
    await nuxt_plugin_image_7d68b96d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_interpolation_108ad0f8 === 'function') {
    await nuxt_plugin_interpolation_108ad0f8(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_365f2721 === 'function') {
    await nuxt_plugin_portalvue_365f2721(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3a8ae409 === 'function') {
    await nuxt_plugin_pluginutils_3a8ae409(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_79629314 === 'function') {
    await nuxt_plugin_pluginrouting_79629314(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_29c150db === 'function') {
    await nuxt_plugin_pluginmain_29c150db(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_3994cfaa === 'function') {
    await nuxt_plugin_dayjsplugin_3994cfaa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_db3c871c === 'function') {
    await nuxt_plugin_axios_db3c871c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginnuxt2client_0e2fb0de === 'function') {
    await nuxt_plugin_pluginnuxt2client_0e2fb0de(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_04127c06 === 'function') {
    await nuxt_plugin_deviceplugin_04127c06(app.context, inject)
  }

  if (typeof nuxt_plugin_bus_74da53e4 === 'function') {
    await nuxt_plugin_bus_74da53e4(app.context, inject)
  }

  if (typeof nuxt_plugin_globalvars_698bce5e === 'function') {
    await nuxt_plugin_globalvars_698bce5e(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_6788fac9 === 'function') {
    await nuxt_plugin_dayjs_6788fac9(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_transitions_02e2df22 === 'function') {
    await nuxt_plugin_transitions_02e2df22(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefinalmodal_130811df === 'function') {
    await nuxt_plugin_vuefinalmodal_130811df(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notifications_36de4932 === 'function') {
    await nuxt_plugin_notifications_36de4932(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videobg_32dbd9e4 === 'function') {
    await nuxt_plugin_videobg_32dbd9e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_excelexport_8371eefa === 'function') {
    await nuxt_plugin_excelexport_8371eefa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vercel_006a881a === 'function') {
    await nuxt_plugin_vercel_006a881a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2smoothscroll_c0a59916 === 'function') {
    await nuxt_plugin_vue2smoothscroll_c0a59916(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78651e70 === 'function') {
    await nuxt_plugin_aos_78651e70(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
